import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";

export function getProductInfoFromList(state: CustomApplicationState, productId: string) {
    if(state.cpeState.ahriRelatedProductState?.ahriRelatedProductInfosByLineId) {
        return state.cpeState.ahriRelatedProductState?.ahriRelatedProductInfosByLineId[productId]
    }
}
